// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"4aaeb895","376":"4aaeb895"}[chunkId] + ".chunk.css";
};